module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_8003.0194f149.png";